/** "cctv" module backend async validators keys */
export enum CctvCheckersEnum {
  /** Check whether car category(ies) with received ID(s) exist(s) */
  CAR_CATEGORY_ASSERT_EXISTS_BY_ID = 'cctv/car-category-assert-exists-by-id',
  /** Check whether car category(ies) with ID(s) received DTO(s) exist(s) */
  CAR_CATEGORY_ASSERT_EXISTS_BY_DTO = 'cctv/car-category-assert-exists-by-dto',
  /** Check whether resident car(s) with received ID(s) exist(s) */
  RESIDENT_CAR_ASSERT_EXISTS_BY_ID = 'cctv/resident-car-assert-exists-by-id',
  /** Check whether resident car(s) with ID(s) received DTO(s) exist(s) */
  RESIDENT_CAR_ASSERT_EXISTS_BY_DTO = 'cctv/resident-car-assert-exists-by-dto',
  /** Check whether transit task(s) with received ID(s) exist(s) */
  TRANSIT_TASK_ASSERT_EXISTS_BY_ID = 'cctv/TRANSIT_TASK_ASSERT_EXISTS_BY_ID',
  /** Check whether transit task(s) with ID(s) received DTO(s) exist(s) */
  TRANSIT_TASK_ASSERT_EXISTS_BY_DTO = 'cctv/TRANSIT_TASK_ASSERT_EXISTS_BY_DTO',
}
